import React, { FC, memo } from 'react';

import { withProviders } from 'application/helpers';
import PlayerProvider from 'application/providers/PlayerProvider';

import { DATA_TEST_IDS } from '../consts';
import { TEXTS } from '../texts';
import { PROMO_MOCK_TOTAL_COUNT } from './fixtures';
import PromoSelectTrigger from './PromoSelectTrigger';
import PromoSelectorDropdown from './PromoSelectorDropdown';
import { usePromoFieldShellViewModel } from './usePromoFieldShellViewModel';

import styles from './index.module.scss';

const PromoFieldShell: FC = () => {
  const {
    containerRef,
    dropdownId,
    dropdownState,
    hasMoreItems,
    isDropdownOpen,
    isLoadingMore,
    items,
    selectedCount,
    selectedPromoIdSet,
    onDropdownToggle,
    onLoadMore,
    onPromoPlaybackToggle,
    onPromoSelectionChange,
    onReset,
  } = usePromoFieldShellViewModel();

  return (
    <div
      className={styles.container}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SHELL}
      ref={containerRef}>
      <span
        id={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_LABEL}
        className={styles.label}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_LABEL}>
        {TEXTS.AUDIO_REPORT_PROMOS_LABEL}
      </span>

      <PromoSelectTrigger
        dropdownId={dropdownId}
        isOpen={isDropdownOpen}
        selectedCount={selectedCount}
        totalCount={PROMO_MOCK_TOTAL_COUNT}
        onClick={onDropdownToggle}
      />

      {isDropdownOpen && (
        <PromoSelectorDropdown
          dropdownId={dropdownId}
          dropdownStyle={{
            position: 'fixed',
            height: dropdownState.maxHeight,
            maxHeight: dropdownState.maxHeight,
            top: dropdownState.fixedPosition?.top,
            left: dropdownState.fixedPosition?.left,
            width: dropdownState.fixedPosition?.width,
          }}
          hasMoreItems={hasMoreItems}
          isLoadingMore={isLoadingMore}
          items={items}
          selectedCount={selectedCount}
          selectedPromoIdSet={selectedPromoIdSet}
          onLoadMore={onLoadMore}
          onPromoPlaybackToggle={onPromoPlaybackToggle}
          onPromoSelectionChange={onPromoSelectionChange}
          onReset={onReset}
        />
      )}
    </div>
  );
};

export { PromoFieldShell };

export default memo(withProviders(PromoFieldShell, [PlayerProvider]));
